import { FunctionComponent, memo, useCallback, SyntheticEvent } from 'react';

import Currency from '~components/Currency';
import { Price } from '~ui/index';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GetName, SteamItemImage } from '~components/item';

import {
  EventUser as EventUserTypes,
  Item as ItemType,
  Profile as ProfileType,
} from '~types';
import _ from 'lodash';

interface Props {
  getWinner: EventUserTypes;
  getPrize: ItemType;
  getProfile: ProfileType;
  index: number;
}

export const Winner: FunctionComponent<Props> = memo(
  ({ getWinner, index, getPrize, getProfile }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const goUser = useCallback(
      (event: SyntheticEvent) => {
        event.preventDefault();

        if (getWinner) {
          navigate(`/user/${getWinner?.getUser?.id}`);
        }
      },
      [getWinner],
    );

    return (
      <div className="in-case-item active status-1" data-rar={getPrize.color}>
        <div className="in-case-item-wrap">
          <div className="img">
            <div className="winner-num">
              <span>#{index}</span>
            </div>
            {getPrize.isStatTrak && (
              <div className="other-labels-item">
                <div className="stattrack">StatTrak™</div>
              </div>
            )}
            <div className="in-case-item-bg" />
            <SteamItemImage url={getPrize.getImage} size="350x350" />
          </div>
          <div className="in-case-info">
            <div className="in-case-item-name">
              <GetName getItem={getPrize} type={0} />
            </div>
            <div className="in-case-item-desc">
              <GetName getItem={getPrize} type={1} />
              {getPrize?.quality && `- ${getPrize?.quality}`}
            </div>
          </div>
          <div className="user">
            <div className="user-ava" onClick={goUser}>
              <img
                src={
                  getWinner?.getUser?.avatar ||
                  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAIAAAgABJ60+RsAAAAASUVORK5CYII='
                }
                alt={getWinner?.getUser?.userName || '-'}
              />
            </div>
            {getWinner?.getUser?.userName && (
              <span className="user-info">
                <span className="user-name">
                  {getWinner?.getUser?.userName}
                  {getWinner?.getUser?.id === getProfile?.id && (
                    <span className="you">({t('You')})</span>
                  )}
                </span>
                {getWinner?.spent && (
                  <span className="user-money">
                    <Price sum={getWinner?.spent} /> <Currency />
                  </span>
                )}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  },
);
